const setQuery = function setQuery(to) {
  return { companyid: to.query.companyid, membersourceid: to.query.membersourceid };
};

export default [
  // for menu
  { path: '/MemberInfo', redirect: (to) => ({ name: 'index', query: setQuery(to) }) },
  { path: '/PersonalInfo', redirect: (to) => ({ name: 'personalInfo', query: setQuery(to) }) },
  { path: '/RedeemItem', redirect: (to) => ({ name: 'redeemList', query: setQuery(to) }) },
  { path: '/ShoppingHistory', redirect: (to) => ({ name: 'order', query: setQuery(to) }) },
  { path: '/UserPointsHistory', redirect: (to) => ({ name: 'pointHistory', query: setQuery(to) }) },
  { path: '/RedeemHistory', redirect: (to) => ({ name: 'redeemHistory', query: setQuery(to) }) },
  { path: '/Notification', redirect: (to) => ({ name: 'notification', query: setQuery(to) }) },
  { path: '/ReturnRequest', redirect: (to) => ({ name: 'returnRequest', query: setQuery(to) }) },
  { path: '/ElectronicTicket', redirect: (to) => ({ name: 'mcfwallet', query: setQuery(to) }) },
  // for Footer
  { path: '/MemberCentreHomePage', redirect: (to) => ({ name: 'index', query: setQuery(to) }) },
  // for key indicator
  { path: '/KeyIndicatorsExchangeProduct', redirect: (to) => ({ name: 'redeemList', query: setQuery(to) }) },
  { path: '/RedeemItemWriteOffTotalQty', redirect: (to) => ({ name: 'redeemHistory', query: setQuery(to) }) },
  { path: '/RedeemItemNotWrittenOffQty', redirect: (to) => ({ name: 'redeemHistory', query: setQuery(to) }) },
];
